import { defineStore } from 'pinia';
import color2rgba from 'color2rgba';
import request from '@/utils/request';

export const useConfigStore = defineStore('config', {
  state: () => ({
    _config: {
      color: '#079aFF', // 主题色
      colorInverse: '#fff', // 反色
      logo: 'https://image.whzb.com/chain/StellarUI/logo.png', // Logo
      loginBg: 'https://image.whzb.com/chain/StellarUI/image/pc-bg.png',
      loginQrSize: 360,
    },
    _style: {},
  }),
  actions: {
    async initConfig() {
      try {
        const conf = await request.get('/config', { params: { key: 'doct-view-config' } });
        if (conf.config_value) {
          let value = conf.config_value;
          if (typeof value === 'string') {
            value = JSON.parse(value);
          }
          Object.assign(this._config, value);
        }
      } catch (e) { }
      // 设置element组件库主题色
      document.documentElement.style.setProperty('--el-color-primary', this._config.color);
      Object.assign(this._style, {
        '--root-color': this._config.color,
        '--color-inverse': this._config.colorInverse,
        '--box-shadow': `rgba(${color2rgba(this._config.color, 0.2).join(',')})`,
        '--page-bg': `rgba(${color2rgba(this._config.color, 0.05).join(',')})`,
        '--page-bg-active': `rgba(${color2rgba(this._config.color, 0.1).join(',')})`,
        '--login-bg': `url(${this._config.loginBg})`,
        '--login-qr-size': `${this._config.loginQrSize}px`,
      });
    },
  },
  getters: {
    config: (state) => state._config,
    rootStyle: (state) => state._style,
  },
});
